module.exports = __webpack_public_path__ + "./images/9ea6201ea2bfdd7f83331ae72dfbdf69.webp";